import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Section, Eyebrow } from "@/components/PublicLayout";
import { FileText, Video, FlaskConical, Presentation } from "lucide-react";

const ICON = { video: Video, portfolio: FileText, research: FlaskConical, presentation: Presentation };

export default function Research() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/research").then((r) => setData(r.data)); }, []);
  return (
    <Section className="py-16 md:py-24">
      <Eyebrow>Research &amp; student work</Eyebrow>
      <h1 className="font-serif text-4xl md:text-6xl tracking-tight text-ink">Evidence, not adjectives.</h1>
      <p className="mt-5 max-w-2xl text-ink/65 leading-relaxed">{data?.note || "The evidence library publishes approved student work only, with guardian consent for minors."}</p>
      <div className="mt-12 grid md:grid-cols-2 gap-px bg-border border border-border">
        {(data?.student_work || []).map((w, i) => {
          const Icon = ICON[w.type] || FileText;
          return (
            <div key={i} className="bg-paper p-7">
              <div className="flex items-center gap-3">
                <Icon className="h-5 w-5 text-heraldic" />
                <span className="font-mono text-xs uppercase text-ink/40">{w.type} · {w.age_band} · {w.language}</span>
              </div>
              <div className="mt-3 font-serif text-xl text-ink">{w.title_en}</div>
              <div className="mt-3 inline-block border border-border px-2.5 py-1 rounded-sm text-xs text-ink/45">
                {w.subject} · {w.language}
              </div>
            </div>
          );
        })}
      </div>
    </Section>
  );
}
